<template>
  <div>
    <a-modal
      :visible="visible"
      :maskClosable="false"
      :closable="closable"
      wrapClassName="custom-modal"
      @cancel="handleCancel"
      :width="width"
      :dialogClass="className"
    >
      <template slot="title">
        {{ title }}
      </template>
      <template slot="closeIcon">
        <img :src="Cross" alt="Cross" />
      </template>
      <slot></slot>
      <template slot="footer">
        <a-row type="flex" justify="space-between">
          <a-col>
            <slot name="extra"></slot>
          </a-col>
          <a-row type="flex" align="middle" justify="end" :gutter="[6, 0]">
            <template v-if="isCustomButton">
              <slot name="button"></slot>
            </template>
            <template v-else-if="!isCustomButton">
              <a-col>
                <Button :ghost="true" @click="handleCancel">
                  Cancel
                </Button>
              </a-col>
              <a-col>
                <Button :type="type" @click="handleOk" :loading="loading" :disabled="disabled">
                  {{ generateOkText }}
                </Button>
              </a-col>
            </template>
          </a-row>
        </a-row>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { Button } from "@/components";
import { Cross } from "@/assets";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    width: {
      type: [Number, String],
      default: 800,
    },
    type: {
      type: String,
      default: "primary",
    },
    isCustomButton: {
      type: Boolean,
      default: false,
    },
    viewDetail: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
    },
    closable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Button,
  },
  data() {
    return { Cross };
  },
  computed: {
    generateOkText() {
      if (this.viewDetail) return "Close";
      switch (this.type) {
        case "create":
          return "Create";
        case "import":
          return "Import";
        case "edit":
          return "Save";
        case "remove":
          return "Delete";
        default:
          return "Create";
      }
    },
  },
  methods: {
    handleOk() {
      this.$emit("onOk");
    },
    handleCancel() {
      this.$emit("onCancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  display: flex;
  justify-content: space-between;
}

::v-deep .custom-modal {
  .ant-modal-content {
    font-size: 24px;
    .ant-modal-header {
      background-color: #fff;
      .ant-modal-title {
        font-weight: 700;
        font-size: 25px;
        color: #00202e;
        line-height: 30px;
      }
    }
    .ant-modal-body {
      font-weight: 400;
      font-size: 14px;
      color: #29444f;
      .list-item {
        padding-left: 30px;
        .item {
          font-style: italic;
        }
      }
    }
  }
}

::v-deep .modal-annual-leave {
  .ant-modal-body {
    padding: 26px 80px;
  }
}
</style>
